import axiosInstance from '@/api/axios'

// 获取订单列表
export function leHealthyApi(): Promise<any> {
    return axiosInstance({
        url: '/web/menu/leHealthy',
        method: 'post',
    })
}
